import SearchBusinessResults from "./SearchBusinessResults";

export default SearchBusinessResults;
